import React, { useEffect, useState } from "react";
import "../assets/css/boothDetail.css";
import { useDispatch, useSelector } from "react-redux";
import { db } from "../firebase";
import { makeStyles } from "@material-ui/core/styles";
import {
  BoothInfo,
  LiveBox,
  ProfileBox,
  // QuestionForm,
  OpusBox,
  ChatBox,
  CheerTicketBox,
} from "../components/booths";
import { HeaderBar } from "../components/header";
import { setBoothId } from "../reducks/booths/operations";
import { FooterBoxDetail } from "../components/footer";
// import { getUserId } from "../reducks/users/selectors";

const useStyles = makeStyles((theme) => ({
  boothName: {
    fontFamily: "ヒラギノ角ゴシック",
    fontWeight: 500,
    boxOrient: "vertical",
    display: "-webkit-box",
    color: "white",
    fontSize: 19,
    lineHeight: "20px",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      height: 22,
      lineClamp: 1,
    },
    [theme.breakpoints.up("md")]: {
      height: 22,
      lineClamp: 1,
    },
  },
  sliderBox: {
    margin: "0 auto",
    backgroundColor: "red",
    width: 250,
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto",
      width: 250,
    },
    [theme.breakpoints.up("sm")]: {
      margin: "0 auto",
      width: 250,
    },
  },
  detail: {
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto 16px auto",
      height: 320,
      width: 320,
    },
    [theme.breakpoints.up("sm")]: {
      margin: "0 auto",
      height: "auto",
      width: 400,
    },
  },
  price: {
    fontSize: 36,
  },
  liveContainer: {
    zIndex: 2,
    position: "fixed",
    width: "100%",
    height: 200,
    backgroundColor: "black",
    borderBottom: "solid 2px rgb(233, 233, 233)",
    [theme.breakpoints.up("sm")]: {
      width: "80%",
      // backgroundColor: "blue",
    },
  },
  liveContainerWide: {
    zIndex: 2,
    position: "fixed",
    // width: "450px",
    top: "5%",
    right: "55%",
  },
  flexRow: {
    display: "flex",
    // flexFlow: "row wrap",
    flexFlow: "row",
    justifyContent: "space-around",
  },
  chatPotition: {
    potition: "fixed",
  },
  displayNone: {
    display: "none",
  },
  wideDisplayFlex: {
    display: "flex",
  },
}));

const BoothDetail = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  // const userID = getUserId(selector);
  const path = selector.router.location.pathname;
  const id = path.split("/boothlist/")[1];
  const [opusData, setOpusData] = useState([]);
  const [booth, setBooth] = useState({});
  const [isWidthWide, setIsWidthWide] = useState(false);
  // console.log(booth);
  // console.log(opusData);

  // const createMovies = async () => {
  //   console.log("発火");
  //   const snapshots = await db.collection("booths").doc(id).collection("movies").get();
  //   snapshots.docs.map((doc) => {
  //     console.log(doc.data());
  //   });
  // };

  const createOpusData = () => {
    db.collection("booths")
      .doc(id)
      .get()
      .then((doc) => {
        const data = doc.data();
        const selectOpuses = data.selectOpuses;
        setOpusData(selectOpuses);
      });
  };

  const createBoothData = () => {
    db.collection("booths")
      .doc(id)
      .get()
      .then((doc) => {
        const data = doc.data();
        setBooth(data);
      });
  };

  useEffect(() => {
    createBoothData();
    createOpusData();
    dispatch(setBoothId(id));

    const wideAction = () => {
      if (1024 < window.innerWidth) {
        setIsWidthWide(true);
      } else {
        setIsWidthWide(false);
      }
    };
    window.addEventListener("resize", wideAction, {
      capture: false,
      passive: true,
    });
    wideAction();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <section className="common-container">
        <div className="detaile-containerr--inner center-box">
          {booth && (
            <div>
              <div className="back-black">
                <HeaderBar />
                <div className={isWidthWide ? classes.flexRow : ""}>
                  <div>
                    <div className={isWidthWide ? classes.liveContainerWide : classes.liveContainer}>
                      <LiveBox youtubeApiKey={booth.youtubeApiKey} youtubeChannelId={booth.youtubeChannelId} />
                      {isWidthWide !== false ? (
                        <>
                          <div className="spacer-box--m"></div>
                          <div>
                            <ChatBox boothId={id} />
                          </div>
                          <div className="spacer-box--l"></div>
                        </>
                      ) : (
                        <div></div>
                      )}
                    </div>
                    <div className="live-container--foundation"></div>
                    {/* <div className={isWidthWide ? classes.wideDisplayFlex : classes.displayNone}>
                    <QuestionForm boothID={id} organizerID={booth.uid} userID={userID} />
                  </div> */}
                  </div>
                  <div>
                    <div className="slider-img-box">
                      <OpusBox key={opusData} opusData={opusData} boothId={id} organzerId={booth.uid} />
                    </div>
                    <div className="spacer-box--m"></div>
                    {booth.isCheer && (
                      <CheerTicketBox
                        opusData={opusData}
                        cheerPrice={booth.cheerPrice}
                        boothId={id}
                        title={booth.boothName}
                        liveSchedule={booth.liveSchedule}
                      />
                    )}
                    <div className="spacer-box--m"></div>
                    <div className="grey-line" />

                    {isWidthWide !== true ? (
                      <>
                        <div className="spacer-box--m"></div>
                        <div className="basic-text__style center text-white bold yu-gotick">コメント掲示板</div>
                        <div className="spacer-box--m"></div>
                        <div>
                          <ChatBox boothId={id} />
                        </div>
                      </>
                    ) : (
                      <div>{/* <ChatBox boothId={id} /> */}</div>
                    )}

                    {/* <QuestionForm boothID={id} organizerID={booth.uid} userID={userID} /> */}
                    <div className="spacer-box--m"></div>

                    <div className="grey-line" />
                    <div className="spacer-box--m"></div>
                    <BoothInfo boothName={booth.boothName} description={booth.description} rules={booth.rules} />
                    <div className="spacer-box--m"></div>
                    <div className="grey-line" />
                    <div className="spacer-box--m"></div>
                    <ProfileBox organizerName={booth.organizerName} uid={booth.uid} />
                    <div className="spacer-box--l"></div>
                    <FooterBoxDetail />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};
export default BoothDetail;
